import { render, staticRenderFns } from "./TimetableStatic.vue?vue&type=template&id=275b01f9&"
import script from "./TimetableStatic.vue?vue&type=script&lang=js&"
export * from "./TimetableStatic.vue?vue&type=script&lang=js&"
import style0 from "@/assets/hometeacher/css/main.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports